import { useEditor } from '@smartfire/js-block-engine'
import React from 'react'
import Obfuscate from 'react-obfuscate'
import { ButtonBlockProps } from '../../button/block'
import style from './style.module.scss'
import clsx from 'clsx'

export const Button: React.FC<ButtonBlockProps> = ({
    text,
    fullWidth,
    isDownload,
    link,
    type,
    blank,
    Wrapper = 'a',
    picto,
    isInternal,
    ...props
}) => {
    const { isEditing } = useEditor()
    const Tag = ({ tagName, children, ...props }) =>
        React.createElement(isEditing ? 'div' : tagName, props, children)
    const btnClass = clsx(style.button, style[type], fullWidth && style.fullWidth)
    const btnContent = (
        <>
            {picto && <i className={'fi ' + picto} />}

            {type === 'angle' && <i className="fi-rs-angle-small-right" />}

            <span className={style.text}>{text}</span>

            {(type === 'arrow' || type === 'filled-arrow') && <i className="fi-rs-arrow-right" />}
        </>
    )

    if (link.includes('mailto:') || link.includes('tel:')) {
        const linkToObfuscate = link.replace('mailto:', '').replace('tel:', '')
        return (
            <div className={btnClass}>
                <Obfuscate
                    element={isEditing ? 'div' : Wrapper}
                    email={link.includes('mailto:') ? linkToObfuscate : undefined}
                    tel={link.includes('tel:') ? linkToObfuscate : undefined}
                    obfuscateChildren={false}
                    {...props}
                    >
                    {btnContent}
                </Obfuscate>
            </div>
        )
    }
    return (
        <Tag
            tagName={Wrapper}
            href={link}
            target={blank ? '_blank' : ''}
            className={btnClass}
            rel={!isInternal ? 'noopener noreferrer' : ''}
            download={isDownload}
            {...props}
        >
            {btnContent}
        </Tag>
    )
}
export default Button
